import { normalizePhoneE164 } from './phoneAddresses.js';

export const GROUP_FALLBACK_THREAD = 'group-text';
const GROUP_THREAD_PREFIX = 'group:';
export const MAX_GROUP_PARTICIPANTS = 9;
const E164 = /^\+[1-9]\d{7,14}$/;

/** The thread key for a group: "group:" + every other person's E.164 number, sorted, comma-separated. The mirror uses the same key. */
export function groupThreadKey(phones = []) {
    const clean = [...new Set((Array.isArray(phones) ? phones : []).map((phone) => normalizePhoneE164(String(phone || ''))).filter((phone) => E164.test(phone)))].sort();
    return `${GROUP_THREAD_PREFIX}${clean.join(',')}`;
}

/** The people on a group thread key (E.164 numbers), or [] for anything that is not a listed group. */
export function groupParticipants(contactPhone) {
    const text = typeof contactPhone === 'string' ? contactPhone.trim() : '';
    if (!text.startsWith(GROUP_THREAD_PREFIX)) return [];
    return text.slice(GROUP_THREAD_PREFIX.length).split(/[,;|]/).map((part) => part.trim()).filter((part) => E164.test(part));
}

/** Can these numbers start a group text? 2 to 9 distinct phone numbers. Returns { valid, phones, error }. */
export function validateNewGroup(phones = []) {
    const list = [...new Set((Array.isArray(phones) ? phones : []).map((phone) => normalizePhoneE164(String(phone || ''))))];
    if (list.some((phone) => !E164.test(phone))) return { valid: false, phones: [], error: 'Every person in a group text needs a phone number with its country code.' };
    if (list.length < 2) return { valid: false, phones: [], error: 'A group text needs at least two people.' };
    if (list.length > MAX_GROUP_PARTICIPANTS) return { valid: false, phones: [], error: `A group text can have up to ${MAX_GROUP_PARTICIPANTS} people.` };
    return { valid: true, phones: list.sort(), error: '' };
}


export function replyBlockedReason(session) {
    if (!['sms', 'mms'].includes(String(session?.channel || 'sms').toLowerCase())) return '';
    if (String(session?.external_thread_id || '').startsWith('conversations:')) return '';
    const contact = String(session?.contact_phone || '').trim();
    if (contact === GROUP_FALLBACK_THREAD || contact.startsWith('group:')) return 'This imported group is read-only. Send individual messages to its members.';
    if (/^\d{5,6}$/.test(contact)) return 'This sender is a short code (like an automated service). It can’t receive replies.';
    if (/[A-Za-z]/.test(contact)) return 'This sender is a name, not a phone number. It can’t receive replies.';
    return '';
}

export function threadBusinessNumber(session) {
    const match = /:(\+[1-9]\d{7,14})$/.exec(String(session?.external_thread_id || ''));
    return match ? match[1] : '';
}
